import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect, useRef, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
import {
  Button,
  ConfigProvider,
  Divider,
  List,
  Modal,
  Popconfirm,
  Radio,
  Table,
  message,
} from "antd";
import CanvasDraw from "react-canvas-draw";
import { DeleteOutlined } from "@ant-design/icons";
import ReactCrop from "react-image-crop";
import CustomButton from "../../../component/CustomButton";
import { debounce } from "lodash";
import { FaRegHand } from "react-icons/fa6";
import { RxCrosshair2 } from "react-icons/rx";
import { BsFillPatchPlusFill, BsPatchMinusFill } from "react-icons/bs";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import Draggable from "react-draggable";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
const OpgSegmentAnalysis = (props) => {
  const { id, idAnalyses } = useParams();
  let navigate = useNavigate();

  const canvasRef = useRef(null);
  const canvasCropRef = useRef(null);

  const SvgRef = useRef(null);

  const [mousePosition, setMousePosition] = useState({ x: null, y: null });

  const [during_Draw_mousePosition, set_during_Draw_MousePosition] = useState({
    x: null,
    y: null,
  });

  const [isNewDrawing, setIsNewDrawing] = useState(false);

  const [startPointState, setStartPointState] = useState({ x: null, y: null });

  const [DisableDrage, setDisbaleDrage] = useState(false);

  const [editMode, setEditmode] = useState(true);
  const [objEdit, setObjEdit] = useState(null);

  const [_Photo, setPhoto] = useState(null);
  const [listRectangle, setListRectangle] = useState([]);
  const [scale, setScale] = useState(1);

  const [_showModalSelectClass, setshowModalSelectClass] = useState(false);
  const [objectLabel, setObjectLabel] = useState(null);
  const [NumberTooth, setNumberTooth] = useState(null);
  const [ToothIntact, setToothIntact] = useState(null);
  const [ToothJaw, setToothJaw] = useState(null);

  const [orderPoint, setOrderPoint] = useState(0);
  const [selectPoint, setSelectPoint] = useState({});

  const [scaleSingleTooth, setScaleSingleTooth] = useState(2);
  const [hideLable, setHideLabel] = useState(false);

  const [listPointSegment, setListpointSegment] = useState([]);
  const [segmentType, setSegmentType] = useState(null);

  const [listSegment, setListSegment] = useState([]);

  useEffect(() => {
    GetImage();
  }, []);

  useEffect(() => {
    if (listRectangle.length > 0) {
      _drawList();
    }
  }, [listRectangle]);

  useEffect(() => {
    const canvasCrop = canvasCropRef.current;
    if (canvasCrop == null) {
      return;
    }
    const ctxCrop = canvasCrop.getContext("2d");

    var imageObj1 = new Image();
    imageObj1.src = ImagePreAddress + _Photo?.imageUrl;

    const points = [
      {
        x: (objectLabel.point1.x - objectLabel.UpLeft.x) * scaleSingleTooth,
        y: (objectLabel.point1.y - objectLabel.UpLeft.y) * scaleSingleTooth,
      }, // { x, y }
      {
        x: (objectLabel.point2.x - objectLabel.UpLeft.x) * scaleSingleTooth,
        y: (objectLabel.point2.y - objectLabel.UpLeft.y) * scaleSingleTooth,
      },
      {
        x: (objectLabel.point3.x - objectLabel.UpLeft.x) * scaleSingleTooth,
        y: (objectLabel.point3.y - objectLabel.UpLeft.y) * scaleSingleTooth,
      },
      {
        x: (objectLabel.point4.x - objectLabel.UpLeft.x) * scaleSingleTooth,
        y: (objectLabel.point4.y - objectLabel.UpLeft.y) * scaleSingleTooth,
      },
    ];
    imageObj1.onload = function () {
      ctxCrop.fillStyle = "black";
      ctxCrop.fillRect(0, 0, canvasCrop.width, canvasCrop.height);

      // Start defining the clipping path
      ctxCrop.save();
      ctxCrop.beginPath();
      ctxCrop.moveTo(points[0].x, points[0].y);
      ctxCrop.lineTo(points[1].x, points[1].y);
      ctxCrop.lineTo(points[2].x, points[2].y);
      ctxCrop.lineTo(points[3].x, points[3].y);
      ctxCrop.closePath();
      ctxCrop.clip();

      // Draw the image inside the clipped area
      ctxCrop.drawImage(
        imageObj1,
        objectLabel.UpLeft.x,
        objectLabel.UpLeft.y,
        objectLabel.w,
        objectLabel.h,
        0,
        0,
        objectLabel.w * scaleSingleTooth,
        objectLabel.h * scaleSingleTooth
      );

      console.log(listPointSegment);

      // Restore the canvas state to remove the clipping path
      ctxCrop.restore();

      ctxCrop.strokeStyle = "red"; // Line color
      ctxCrop.lineWidth = 2; // Line width
      ctxCrop.beginPath();

      // Assuming listPointSegment is an array of {x, y} objects
      if (listPointSegment.length > 0) {
        ctxCrop.moveTo(listPointSegment[0].x, listPointSegment[0].y); // Start at the first point

        for (let i = 1; i < listPointSegment.length; i++) {
          ctxCrop.lineTo(listPointSegment[i].x, listPointSegment[i].y); // Draw a line to the next point
        }
      }
      if (listPointSegment.length == 1) {
        ctxCrop.arc(
          listPointSegment[0].x,
          listPointSegment[0].y,
          1,
          0,
          2 * Math.PI
        );
      }

      ctxCrop.stroke();
    };
  }, [objectLabel, listPointSegment]);
  const GetPatientPhoto = async () => {
    let url = Url.GetPhotoForNumberOpg;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    setPhoto(res?.data);
  };

  const GetImage = async () => {
    let url = Url.opgsegmentGetPhoto;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: parseInt(id),
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    setPhoto(res?.data?.patientImage);

    let RectangleList = [];

    if (res?.data?.patientImage?.opgNumberingAnalysis.length <= 0) {
      return;
    }
    RectangleList =
      res?.data?.patientImage?.opgNumberingAnalysis[0]?.opgNumberingAnalysisDetails?.map(
        (o) => {
          let findUpLeftX = Math.min(
            o.x1 * scale,
            o.x2 * scale,
            o.x3 * scale,
            o.x4 * scale
          );
          let findUpLeftY = Math.min(
            o.y1 * scale,
            o.y2 * scale,
            o.y3 * scale,
            o.y4 * scale
          );
          let findBottonRightX = Math.max(
            o.x1 * scale,
            o.x2 * scale,
            o.x3 * scale,
            o.x4 * scale
          );
          let findBottonRightY = Math.max(
            o.y1 * scale,
            o.y2 * scale,
            o.y3 * scale,
            o.y4 * scale
          );

          let w = findBottonRightX - findUpLeftX;
          let h = findBottonRightY - findUpLeftY;

          let obj = {};
          obj.uid = uuidv4();
          obj.analysisId = o.opgNumberingAnalysisId;
          obj.analysisDetailId = o.id;
          obj.jaw = o.jaw;
          obj.type = o.type;
          obj.intact = o.type;
          obj.point1 = { x: o.x1 * scale, y: o.y1 * scale };
          obj.point2 = { x: o.x2 * scale, y: o.y2 * scale };
          obj.point3 = { x: o.x3 * scale, y: o.y3 * scale };
          obj.point4 = { x: o.x4 * scale, y: o.y4 * scale };
          obj.toothnumber = o.numberTeeth + o.orientaion;
          obj.w = w;
          obj.h = h;
          obj.UpLeft = { x: findUpLeftX, y: findUpLeftY };
          obj.BottomRight = { x: findBottonRightX, y: findBottonRightY };
          return obj;
        }
      );

    const updateArray = (__list, listTooth) => {
      let updatedData = __list.map((item) => {
        let findtooth = listTooth.find(
          (oo) => oo.analysisDetailId == item.opgNumberingAnalysisDetailId
        );
        return {
          uid: uuidv4(),
          OpgNumberingAnalysisDetailId: item.opgNumberingAnalysisDetailId, // Rename key
          refrenceX: item.refrenceX,
          refrenceY: item.refrenceY,
          jaw: findtooth?.jaw,
          toothnumber: findtooth?.toothnumber,
          type: item.type,
          detailSegment: item.opgSegmentAnalysisDetail.map((detail) => ({
            x: detail.x,
            y: detail.y,
          })),
        };
      });

      return updatedData;
    };
    let listSegment = updateArray(res?.data?.opgSegmentAnalysis, RectangleList);
    setListSegment(listSegment);

    setListRectangle(RectangleList);
  };

  function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  const _drawList = () => {};

  const returnNumberTeethButton = () => {
    const _onClickSubmit = (number) => {
      if (ToothIntact == null) {
        message.warn("نوع دندان مشخص شود");
        return;
      }
      if (ToothJaw == null) {
        message.warn("نوع فک مشخص شود");
        return;
      }

      if (number == undefined && NumberTooth == null) {
        message.warn("شماره  دندان مشخص شود");
        return;
      }

      let newList = [...listRectangle];

      if (number == undefined) {
        objectLabel.toothnumber = NumberTooth;
      } else {
        objectLabel.toothnumber = number;
      }

      objectLabel.intact = ToothIntact;
      objectLabel.jaw = ToothJaw;

      let findIndex = newList.findIndex((obj) => obj.uid == objectLabel.uid);
      if (findIndex >= 0) {
        newList[findIndex] = objectLabel;
      } else {
        newList.push(objectLabel);
      }

      setListRectangle(newList);
      setshowModalSelectClass(false);
    };
    return (
      <div className="text-center">
        <canvas
          ref={canvasCropRef}
          width={objectLabel?.w * (1 / scale)}
          height={objectLabel?.h * (1 / scale)}
          // style={{ backgroundColor: "red" }}
        />
        <div>
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            size="small"
            value={ToothIntact}
            onChange={(e) => setToothIntact(e.target.value)}
          >
            <Radio style={{ width: 70 }} value="intact">
              سالم
            </Radio>
            <Radio style={{ width: 70 }} value="implant">
              ایمپلنت
            </Radio>
            <Radio style={{ width: 70 }} value="rct">
              rct
            </Radio>
            <Radio style={{ width: 70 }} value="notintact">
              غیر سالم
            </Radio>
          </Radio.Group>
        </div>
        <div style={{ marginTop: 10 }}>
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            size="small"
            value={ToothJaw}
            onChange={(e) => setToothJaw(e.target.value)}
          >
            <Radio style={{ width: 70 }} value="maxilla">
              فک بالا
            </Radio>
            <Radio style={{ width: 70 }} value="mandible">
              فک پایین
            </Radio>
          </Radio.Group>
        </div>
        <div style={{ marginTop: 30 }}>
          <Radio.Group
            optionType="button"
            buttonStyle="solid"
            size="small"
            value={NumberTooth}
            onChange={(e) => _onClickSubmit(e.target.value)}
          >
            <Radio value="8L">8</Radio>
            <Radio value="7L">7</Radio>
            <Radio value="6L">6</Radio>
            <Radio value="5L">5</Radio>
            <Radio value="4L">4</Radio>
            <Radio value="3L">3</Radio>
            <Radio value="2L">2</Radio>
            <Radio value="1L">1</Radio>
            <Divider type="vertical" />
            <Radio value="1R">1</Radio>
            <Radio value="2R">2</Radio>
            <Radio value="3R">3</Radio>
            <Radio value="4R">4</Radio>
            <Radio value="5R">5</Radio>
            <Radio value="6R">6</Radio>
            <Radio value="7R">7</Radio>
            <Radio value="8R">8</Radio>

            <div
              className="margin-top"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div>دندان شیری</div>
              <Radio value="EL">E</Radio>
              <Radio value="DL">D</Radio>
              <Radio value="CL">C</Radio>
              <Radio value="BL">B</Radio>
              <Radio value="AL">A</Radio>
              <Divider type="vertical" />
              <Radio value="AR">A</Radio>
              <Radio value="BR">B</Radio>
              <Radio value="CR">C</Radio>
              <Radio value="DR">D</Radio>
              <Radio value="ER">E</Radio>
            </div>
          </Radio.Group>
        </div>
        <Button
          type="primary"
          style={{ marginTop: 20 }}
          onClick={() => _onClickSubmit()}
        >
          Submit
        </Button>
      </div>
    );
  };

  const returnSideBar = () => {
    return (
      <div dir="ltr" className="sidebar">
        <div>
          <div className=" margin-horizontal10 flex-row justify-between">
            <div>
              <FaRegHand
                onClick={() => setEditmode(true)}
                color={editMode ? "green" : "black"}
              />
            </div>
            <div>
              <RxCrosshair2
                onClick={() => setEditmode(false)}
                color={!editMode ? "green" : "black"}
              />
            </div>
          </div>

          <div className="margin-horizontal10">Labels</div>

          <div>
            <ConfigProvider direction="ltr">
              {listSegment.length > 0 && (
                <List
                  split
                  size="small"
                  dataSource={listSegment}
                  renderItem={_renderSideBarItem}
                />
              )}
            </ConfigProvider>
          </div>
        </div>
        <div>
          {/* <CustomButton
            onClick={_getWithAi}
            title="Get With Ai !"
            isLoading={
              props.coreData[Url.PredictTeeth + id]?.[Url.action]?.isFetching
            }
          /> */}
          <CustomButton
            onClick={_onClickSubmit}
            title="Submit"
            isLoading={
              props.coreData[Url.opgSaveSegment + "/" + id]?.[Url.action]
                ?.isFetching
            }
          />
        </div>
      </div>
    );
  };
  const _renderSideBarItem = (item, index) => {
    const Delete = () => {
      let newList = [...listSegment];
      newList = newList.filter((o) => o.uid !== item.uid);
      setListSegment(newList);
    };
    let color = "pink";
    if (item.type == "filling") {
      color = "#0000FF59";
    }
    if (item.type == "caries") {
      color = "#FF000059";
    }
    if (item.type == "implant") {
      color = "#80808059";
    }
    if (item.type == "rct") {
      color = "#00FF0059";
    }
    if (item.type == "post") {
      color = "#FFFF0059";
    }
    if (item.type == "palesion") {
      color = "#12352459";
    }

    const onClickChangeSize = (dir, operation) => {
      let newList = [...listRectangle];
      let findindex = newList.findIndex((obj) => obj.uid == item.uid);
      if (findindex >= 0) {
        if (dir == "x") {
          if (operation == "+") {
            newList[findindex] = {
              ...newList[findindex],
              width: newList[findindex].width + 5,
            };
          }
          if (operation == "-") {
            newList[findindex] = {
              ...newList[findindex],
              width: newList[findindex].width - 5,
            };
          }
        }
        if (dir == "y") {
          if (operation == "+") {
            newList[findindex] = {
              ...newList[findindex],
              height: newList[findindex].height + 5,
            };
          }
          if (operation == "-") {
            newList[findindex] = {
              ...newList[findindex],
              height: newList[findindex].height - 5,
            };
          }
        }
      }

      setListRectangle(newList);
    };
    return (
      <div>
        <div className="margin-horizontal10 sliderText ">
          <div
            style={{ backgroundColor: color, marginTop: 2 }}
            className="flex-row justify-between "
          >
            <div className="imgdragdisable margin-horizontal10">
              {item.toothnumber}-{item.jaw}-{item?.type}
            </div>
            {/* <div className="flex-row justify-center align-center">
              <div className="imgdragdisable" style={{ marginRight: 2 }}>
                X
              </div>

              <div>
                <FaPlusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("x", "+")}
                />
              </div>
              <div>
                <FaMinusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("x", "-")}
                />
              </div>

              <div
                className="imgdragdisable"
                style={{ marginLeft: 10, marginRight: 2 }}
              >
                Y
              </div>
              <div>
                <FaPlusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("y", "+")}
                />
              </div>
              <div>
                <FaMinusCircle
                  className="plusminusIcon"
                  onClick={() => onClickChangeSize("y", "-")}
                />
              </div>
            </div> */}
            <div className="margin-horizontal10">
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={Delete}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined />
              </Popconfirm>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const _onClickSubmit = async () => {
    console.log(listSegment);

    let url = Url.opgSaveSegment + "/" + id;

    let res = await props.actions.CallCoreServicesActionWithToken(
      url,
      listSegment
    );

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }

    message.success(res.message);
    navigate(-1);
  };

  const _returnSvgElemtent = () => {
    let _output = [];

    let addCss = " ";
    if (editMode) {
      addCss += " rectEdit ";
    }

    const onDoubleClick = (obj) => {
      console.log(obj);
      setObjectLabel(obj);
      setToothJaw(obj.jaw);
      setToothIntact(obj.intact);
      setNumberTooth(obj.toothnumber);
      setListpointSegment([]);

      // setshowModalSelectClass(true);
    };

    const OnStopDragable = (evn, data, object) => {
      console.log(object);
      let newList = [...listRectangle];
      let findindex = newList.findIndex((obj) => obj.uid == object.uid);
      if (findindex >= 0) {
        newList[findindex] = { ...newList[findindex], x: data.x, y: data.y };
      }
      setListRectangle(newList);
    };
    listRectangle.forEach((o) => {
      let color = "pink";
      if (o.intact == "intact") {
        color = "#50cc3d59";
      }
      if (o.intact == "notintact") {
        color = "#cc473d59";
      }
      if (o.intact == "implant") {
        color = "#ebfae859";
      }
      if (o.intact == "rct") {
        color = "#a832a259";
      }
      let point =
        o.point1.x.toString() +
        "," +
        o.point1.y.toString() +
        " " +
        o.point2.x.toString() +
        "," +
        o.point2.y.toString() +
        " " +
        o.point3.x.toString() +
        "," +
        o.point3.y.toString() +
        " " +
        o.point4.x.toString() +
        "," +
        o.point4.y.toString() +
        " " +
        o.point1.x.toString() +
        "," +
        o.point1.y.toString();

      _output.push(
        <>
          <Draggable
            // disabled={!editMode}
            // onStop={(env, data) => OnStopDragable(env, data, o)}
            position={{ x: 0, y: 0 }}
            scale={1}

            // bounds="parent"
          >
            <g onClick={() => onDoubleClick(o)}>
              <polyline
                points={point}
                style={{ fill: "#50cc3d00", stroke: "green", strokeWidth: 1 }}
              />

              <text
                className="imgdragdisable"
                x={(o.UpLeft.x + o.BottomRight.x) / 2 - 10}
                y={(o.UpLeft.y + o.BottomRight.y) / 2}
                fill="black"
              >
                {o.toothnumber}
              </text>
              <text
                className="imgdragdisable"
                x={(o.UpLeft.x + o.BottomRight.x) / 2 - 10}
                y={(o.UpLeft.y + o.BottomRight.y) / 2 + 15}
                fill="black"
              >
                {o.jaw == "mandible" && "Down"}
                {o.jaw == "maxilla" && "Up"}
              </text>
            </g>
          </Draggable>
        </>
      );
    });

    listSegment.forEach((o) => {
      let _listPointForSvg = "";
      let color = "white";

      if (o.type == "filling") {
        color = "#0000FF59";
      }
      if (o.type == "caries") {
        color = "#FF000059";
      }
      if (o.type == "implant") {
        color = "#80808059";
      }
      if (o.type == "rct") {
        color = "#00FF0059";
      }
      if (o.type == "post") {
        color = "#FFFF0059";
      }
      if (o.type == "palesion") {
        color = "#12352459";
      }
      o.detailSegment.forEach((detailObject) => {
        _listPointForSvg +=
          o.refrenceX +
          detailObject.x +
          "," +
          (o.refrenceY + detailObject.y) +
          " ";
      });

      _output.push(
        <>
          <Draggable
            // disabled={!editMode}
            // onStop={(env, data) => OnStopDragable(env, data, o)}
            position={{ x: 0, y: 0 }}
            scale={1}

            // bounds="parent"
          >
            <g>
              <polyline points={_listPointForSvg} style={{ fill: color }} />
            </g>
          </Draggable>
        </>
      );
    });
    return _output;
  };

  let startPoint = { x: null, y: null };
  const _OnMouseDownSvg = (event) => {
    if (DisableDrage) {
      return;
    }

    if (editMode) {
      return;
    }

    setIsNewDrawing(true);

    const svgRect = SvgRef.current.getBoundingClientRect();
    const mouseX = event.clientX - svgRect.left;
    const mouseY = event.clientY - svgRect.top;
    startPoint = { x: mouseX, y: mouseY };
    setStartPointState(startPoint);

    // console.log("Down", mouseX, mouseY);
  };

  const _onMouseMoveSvg = (event) => {
    if (DisableDrage) {
      return;
    }
    const svgRect = SvgRef.current.getBoundingClientRect();
    const mouseX = event.clientX - svgRect.left;
    const mouseY = event.clientY - svgRect.top;

    // console.log("Move", mouseX, mouseY);

    UpdateRect(mouseX, mouseY);
  };

  const _onMouseUpSvg = (event) => {
    if (DisableDrage) {
      return;
    }
    if (editMode) {
      return;
    }

    setIsNewDrawing(false);

    startPoint = { x: null, y: null };
    setStartPointState({ x: null, y: null });
    // setStartPointDrawRectangle({ x: null, y: null });

    let rect = SvgRef.current.querySelector("#newRect");
    if (rect) {
      // Get the bounding box of the SVG element
      let x = rect.x.animVal.value;
      let y = rect.y.animVal.value;
      let w = rect.width.animVal.value;
      let h = rect.height.animVal.value;

      let newClass = {
        uid: uuidv4(),
        x: x,
        y: y,
        width: w,
        height: h,
        type: "1R",
      };

      rect.setAttribute("x", 0);
      rect.setAttribute("y", 0);
      rect.setAttribute("width", 0);
      rect.setAttribute("height", 0);

      setObjectLabel(newClass);
      setNumberTooth(null);
      setToothIntact(null);
      setshowModalSelectClass(true);
    }
  };

  const onClickPoint = (event) => {
    if (editMode) {
      return;
    }

    const svgRect = SvgRef.current.getBoundingClientRect();
    const mouseX = event.clientX - svgRect.left;
    const mouseY = event.clientY - svgRect.top;

    if (orderPoint == 0) {
      setSelectPoint({ point1: { x: mouseX, y: mouseY } });
      setOrderPoint(1);
      return;
    }
    if (orderPoint == 1) {
      setSelectPoint({ ...selectPoint, point2: { x: mouseX, y: mouseY } });
      setOrderPoint(2);
      return;
    }
    if (orderPoint == 2) {
      setSelectPoint({ ...selectPoint, point3: { x: mouseX, y: mouseY } });
      setOrderPoint(3);
      return;
    }
    let point4 = { x: mouseX, y: mouseY };
    if (orderPoint == 3) {
      setSelectPoint({ ...selectPoint, point4: point4 });
    }

    let findUpLeftX = Math.min(
      selectPoint?.point1.x,
      selectPoint?.point2.x,
      selectPoint?.point3.x,
      point4.x
    );
    let findUpLeftY = Math.min(
      selectPoint?.point1.y,
      selectPoint?.point2.y,
      selectPoint?.point3.y,
      point4.y
    );
    let findBottonRightX = Math.max(
      selectPoint?.point1.x,
      selectPoint?.point2.x,
      selectPoint?.point3.x,
      point4.x
    );
    let findBottonRightY = Math.max(
      selectPoint?.point1.y,
      selectPoint?.point2.y,
      selectPoint?.point3.y,
      point4.y
    );

    let w = findBottonRightX - findUpLeftX;
    let h = findBottonRightY - findUpLeftY;

    let newClass = {
      uid: uuidv4(),
      point1: selectPoint.point1,
      point2: selectPoint.point2,
      point3: selectPoint.point3,
      point4: point4,
      w: w,
      h: h,
      UpLeft: { x: findUpLeftX, y: findUpLeftY },
      BottomRight: { x: findBottonRightX, y: findBottonRightY },
      type: "1R",
      jaw: "",
    };

    setObjectLabel(newClass);
    setSelectPoint({});
    setOrderPoint(0);
    setNumberTooth(null);
    setToothIntact(null);
    setshowModalSelectClass(true);
  };

  const UpdateRect = debounce((MouseX, Mousey) => {
    if (startPointState.x != null && startPointState.y != null) {
      let x = Math.min(startPointState.x, MouseX);
      let y = Math.min(startPointState.y, Mousey);
      let w = Math.abs(MouseX - startPointState.x);
      let h = Math.abs(Mousey - startPointState.y);
      // console.log("Update", x, y, w, h);
      let rect = SvgRef.current.querySelector("#newRect");

      // Update the rectangle attributes
      rect.setAttribute("x", x);
      rect.setAttribute("y", y);
      rect.setAttribute("width", w);
      rect.setAttribute("height", h);
      rect.setAttribute("fill", "none");
      rect.setAttribute("stroke", "black"); // Set border color
      rect.setAttribute("stroke-width", "1");
    }
  }, 1);

  const _getWithAi = async () => {
    let url = Url.opgPredictTeeth + id;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let ListBox = JSON.parse(res?.data);

    console.log(ListBox);
    let _outPut = [];

    ListBox.forEach((o) => {
      let x1 = o.x1 * scale;
      let y1 = o.y1 * scale;
      let x2 = o.x2 * scale;
      let y2 = o.y2 * scale;
      let x3 = o.x3 * scale;
      let y3 = o.y3 * scale;
      let x4 = o.x4 * scale;
      let y4 = o.y4 * scale;

      let findUpLeftX = Math.min(o.x1, o.x2, o.x3, o.x4);
      let findUpLeftY = Math.min(o.y1, o.y2, o.y3, o.y4);
      let findBottonRightX = Math.max(o.x1, o.x2, o.x3, o.x4);
      let findBottonRightY = Math.max(o.y1, o.y2, o.y3, o.y4);

      let w = findBottonRightX - findUpLeftX;
      let h = findBottonRightY - findUpLeftY;

      // w: w,
      // h: h,
      // UpLeft: { x: findUpLeftX, y: findUpLeftY },
      // BottomRight: { x: findBottonRightX, y: findBottonRightY },
      // type: "1R",
      // jaw: "",

      let teethType = o.teethType;
      if (!(teethType == "implant" || teethType == "rct")) {
        teethType = "intact";
      }

      _outPut.push({
        uid: uuidv4(),
        point1: { x: x1, y: y1 },
        point2: { x: x2, y: y2 },
        point3: { x: x3, y: y3 },
        point4: { x: x4, y: y4 },

        type: o.teethNumber + o.orientation,
        jaw: o.jaw,
        intact: teethType,

        toothnumber: o.teethNumber + o.orientation,
        w: w,
        h: h,
        UpLeft: { x: findUpLeftX, y: findUpLeftY },
        BottomRight: { x: findBottonRightX, y: findBottonRightY },
      });
    });

    setListRectangle(_outPut);
    setEditmode(true);
  };

  const _returnBoxDuringSelection = () => {
    let point = "";
    let x = 0;
    let y = 0;
    if (selectPoint?.point1) {
      point +=
        selectPoint.point1.x.toString() +
        "," +
        selectPoint.point1.y.toString() +
        " ";
    }
    if (selectPoint?.point2) {
      point +=
        selectPoint.point2.x.toString() +
        "," +
        selectPoint.point2.y.toString() +
        " ";
    }
    if (selectPoint?.point3) {
      point +=
        selectPoint.point3.x.toString() +
        "," +
        selectPoint.point3.y.toString() +
        " ";
    }
    if (selectPoint?.point4) {
      point +=
        selectPoint.point4.x.toString() +
        "," +
        selectPoint.point4.y.toString() +
        " ";
    }

    if (selectPoint.point1 && selectPoint.point2 == undefined) {
      return (
        <circle
          r="2"
          cx={selectPoint.point1.x}
          cy={selectPoint.point1.y}
          fill="green"
        />
      );
    }
    return (
      <polyline
        points={point}
        style={{ fill: "none", stroke: "green", strokeWidth: 3 }}
      />
    );
  };

  const _onClickCanvasSingleTooth = (e) => {
    const canvas = canvasCropRef.current;
    if (canvas == null) {
      return;
    }

    // Get the bounding rectangle of the canvas
    const rect = canvas.getBoundingClientRect();

    // Calculate click position relative to the canvas
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setListpointSegment([...listPointSegment, { id: uuidv4(), x: x, y: y }]);

    console.log(`Clicked position: x=${x}, y=${y}`);
  };

  const onSaveButton = () => {
    let _toServer = {};
    _toServer.uid = uuidv4();
    _toServer.OpgNumberingAnalysisDetailId = objectLabel?.analysisDetailId;
    _toServer.type = segmentType;
    _toServer.toothnumber = objectLabel.toothnumber;
    _toServer.jaw = objectLabel.jaw;
    _toServer.refrenceX = parseInt(objectLabel?.UpLeft?.x);
    _toServer.refrenceY = parseInt(objectLabel?.UpLeft?.y);
    _toServer.detailSegment = [];

    listPointSegment.map((o) => {
      _toServer.detailSegment.push({
        x: parseInt(o.x / scaleSingleTooth),
        y: parseInt(o.y / scaleSingleTooth),
      });
    });

    setListSegment([...listSegment, _toServer]);

    setListpointSegment([]);
  };
  return (
    <div dir="ltr">
      {/* <Modal
        open={_showModalSelectClass}
        onCancel={() => setshowModalSelectClass(false)}
        footer={null}
      >
        {returnNumberTeethButton()}
      </Modal> */}

      <div className="flex-row" style={{ position: "relative" }}>
        {returnSideBar()}
        {_Photo !== null && (
          <div
            className="text-center"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                position: "relative",
                width: _Photo?.imageWidth * scale,
                height: _Photo?.imageHeight * scale,
              }}
            >
              <svg
                ref={SvgRef}
                style={{ zIndex: 1, position: "absolute", top: 0, left: 0 }}
                width={_Photo?.imageWidth * scale}
                height={_Photo?.imageHeight * scale}
                onClick={onClickPoint}
                // onMouseDown={_OnMouseDownSvg}
                // onMouseMove={_onMouseMoveSvg}
                // onMouseUp={_onMouseUpSvg}
              >
                {!hideLable && _returnSvgElemtent()}
                {_returnBoxDuringSelection()}
              </svg>
              <img
                className="imgdragdisable"
                src={ImagePreAddress + _Photo?.imageUrl}
                style={{
                  width: _Photo?.imageWidth * scale,
                  height: _Photo?.imageHeight * scale,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 0,
                }}
              />
            </div>

            <img
              style={{ display: "none" }}
              id="imageOriginal"
              src={ImagePreAddress + _Photo?.imageUrl}
            />
            <Button onClick={() => setHideLabel(!hideLable)}>
              {hideLable ? "Show" : "Hide"}
            </Button>
            <div
              className="text-center"
              style={{
                display: "flex",
                width: "fit-content",
                alignSelf: "center",
              }}
            >
              <canvas
                ref={canvasCropRef}
                width={objectLabel?.w * scaleSingleTooth}
                height={objectLabel?.h * scaleSingleTooth}
                onClick={_onClickCanvasSingleTooth}
                // style={{ backgroundColor: "red" }}
              ></canvas>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                marginTop: 10,
                marginBottom: 2,
              }}
            >
              <Button onClick={() => setListpointSegment([])}>Reset</Button>
            </div>
            <div style={{ marginTop: 10, marginBottom: 2 }}>
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                size="small"
                value={segmentType}
                onChange={(e) => setSegmentType(e.target.value)}
              >
                <Radio style={{ width: 70 }} value="caries">
                  پوسیدگی
                </Radio>
                <Radio style={{ width: 70 }} value="implant">
                  ایمپلنت
                </Radio>
                <Radio style={{ width: 70 }} value="rct">
                  rct
                </Radio>
                <Radio style={{ width: 70 }} value="filling">
                  ترمیم
                </Radio>
                <Radio style={{ width: 70 }} value="post">
                  پست
                </Radio>
                <Radio style={{ width: 70 }} value="palesion">
                  ضایعه
                </Radio>
              </Radio.Group>
            </div>
            <div style={{ marginTop: 10, marginBottom: 2 }}>
              <Button
                disabled={listPointSegment.length <= 2}
                onClick={onSaveButton}
                type="primary"
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(OpgSegmentAnalysis);
